import { api } from "@/services/api"

export const requestLogInLink = async (params: {
  email: string
}) => {
  const { body } = await api.post(
    "/request-login-link-session/",
    {
      body: params,
    }
  )
  return body
}
